export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14030.77269e12.jpg";